import { render, staticRenderFns } from "./DokumanList.vue?vue&type=template&id=188d59b4&scoped=true"
import script from "./DokumanList.vue?vue&type=script&lang=ts"
export * from "./DokumanList.vue?vue&type=script&lang=ts"
import style0 from "./DokumanList.vue?vue&type=style&index=0&id=188d59b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188d59b4",
  null
  
)

export default component.exports